<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  chat: {
    type: Object,
    required: true,
  },
});

const store = useStore();

const getContrastYIQ = hexcolor => {
  if (!hexcolor) return '#ffffff';
  hexcolor = hexcolor.replace('#', '');
  if (hexcolor.length === 3) {
    hexcolor = hexcolor.split('').map(c => c + c).join('');
  }
  const r = parseInt(hexcolor.substring(0, 2), 16);
  const g = parseInt(hexcolor.substring(2, 4), 16);
  const b = parseInt(hexcolor.substring(4, 6), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? '#000000' : '#ffffff';
};

const kanbanTags = computed(() => {
  if (!props.chat || !props.chat.custom_attributes) return [];
  
  const tags = [];
  const attrs = props.chat.custom_attributes;
  
  // Obter todos os atributos customizados de conversa ativos
  const allAttributes = store.getters['attributes/getAttributesByModel']('conversation_attribute');
  
  // Filtrar apenas os que sao do tipo 'list' (Kanban)
  const listAttributes = (allAttributes || []).filter(a => a.attribute_display_type === 'list');
  
  for (const attr of listAttributes) {
    const key = attr.attribute_key;
    if (attrs[key]) {
      // Tentar pegar a cor do JSON salvo na descricao
      let bgColor = '#cbd5e1'; // Default light gray
      if (attr.attribute_description) {
        try {
          const parsed = JSON.parse(attr.attribute_description);
          if (parsed && parsed.colors && parsed.colors[attrs[key]]) {
            bgColor = parsed.colors[attrs[key]];
          }
        } catch (e) {
          // ignore parsing error if it's not valid JSON
        }
      }
      
      tags.push({
        label: attrs[key],
        bgColor: bgColor,
        textColor: getContrastYIQ(bgColor)
      });
    }
  }
  
  return tags;
});
</script>

<template>
  <div class="flex flex-wrap gap-1 mt-1 mb-1" v-if="kanbanTags.length > 0">
    <span
      v-for="(tag, index) in kanbanTags"
      :key="index"
      class="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-semibold max-w-full truncate shadow-sm"
      :style="{ backgroundColor: tag.bgColor, color: tag.textColor }"
      :title="tag.label"
    >
      {{ tag.label }}
    </span>
  </div>
</template>